import { RefObject, useEffect } from 'react';

/**
 * Handles clicks outside of specified refs
 */
export function useClickOutside(
	enabled: boolean,
	onClickOutside: () => void,
	...refs: RefObject<HTMLElement | null>[]
) {
	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			const clickedOutsideAllRefs = refs.every(
				ref => ref.current && !ref.current.contains(event.target as Node),
			);

			if (clickedOutsideAllRefs) {
				onClickOutside();
			}
		}

		if (enabled) {
			document.addEventListener('mousedown', handleClickOutside);
			return () => document.removeEventListener('mousedown', handleClickOutside);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enabled, onClickOutside]);
}
